import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RedDeleteIcon } from "../../../assets/images";
import { LeaveAndUpcomingHistoryListType } from "../../../redux/stcoTools/stcoToolsType";

type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  isDeleteData: any;
  handleDeleteLeave: () => void;
  data: [] | LeaveAndUpcomingHistoryListType[];
  isTypeChange?: string;
};
const DeleteUpcomingLeaves = ({
  toggle,
  isOpen,
  isDeleteData,
  handleDeleteLeave,
  data,
  isTypeChange,
}: AppProps) => {
  return (
    <>
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        size="sm"
        style={{ minWidth: "420px" }}
        backdrop="static"
      >
        <ModalHeader style={{ border: "none" }} toggle={toggle}></ModalHeader>

        <ModalBody>
          <div className="d-flex justify-content-center flex-column align-items-center text-center p-3">
            <img
              src={RedDeleteIcon}
              style={{ width: "32px" }}
              alt="delete-icon"
            />

            <div className="mt-3" style={{ fontSize: "20px", fontWeight: 500 }}>
              Delete {isTypeChange === "WFH" ? "WFH" : "Leave"} request?
            </div>
            <div className="mt-3">
              Are you sure you want to delete{" "}
              {isTypeChange === "WFH" ? "WFH" : "Leave"} request for{" "}
              {isDeleteData?.start_date} to {isDeleteData?.end_date} (
              {isDeleteData?.day} days)?
            </div>
            {data?.length > 1 && isTypeChange === "Leave" ? (
              <div className="mt-2 text-danger" style={{ fontWeight: 600 }}>
                Note: Your leave balance has been updated, kindly Review your
                leave request before taking any further action.
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="mt-2">
            <button
              className="btn btn-primary w-100"
              onClick={handleDeleteLeave}
            >
              Delete
            </button>
          </div>
          <div className="mt-2">
            <button
              style={{ border: "1px solid #dd4433" }}
              className="btn w-100"
              onClick={toggle}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeleteUpcomingLeaves;
